import React, { useState, useEffect, useMemo, useRef } from "react";
import './Contact.css'; // you can style it here
import Select from "react-select";
import countryList from "react-select-country-list";
import {
  trackAnalyticsEvent,
  saveAnalyticsFormDraft,
  markAnalyticsFormSubmitted,
  markAnalyticsFormAbandoned,
} from "../analytics/siteAnalytics";

const contacts = [
  {
    title: 'Product Specialists',
    image: '/images/product-specialist.jpg',
    description: 'Our Product Specialists are experts in optical technologies, ready to assist with any technical questions you may have. Click the button to connect with our team and explore how our solutions can meet your needs.',
    buttonText: 'Contact Us'
  },
  {
    title: 'Service Specialists',
    image: '/images/service-specialist.jpg',
    description: 'Need service support? Our Service Specialists are here to help you troubleshoot and optimize your systems.',
    buttonText: 'Contact Service'
  },
  {
    title: 'Media Inquiries',
    image: '/images/media-inquiries.jpg',
    description: 'For press, media, or public relations inquiries, reach out to our communications team.',
    buttonText: 'Media Contact'
  },
  {
    title: 'Partnerships & Suppliers',
    image: '/images/partnerships.jpg',
    description: 'Interested in partnering with us? Let’s collaborate to create future-focused solutions.',
    buttonText: 'Partner with Us'
  },
  {
    title: 'Customer Support',
    image: '/images/support.jpg',
    description: 'Our customer support team is always ready to help you with your needs and questions.',
    buttonText: 'Get Support'
  },
  {
    title: 'Career Opportunities',
    image: '/images/careers.jpg',
    description: 'Explore exciting career opportunities and become part of our innovative team.',
    buttonText: 'Join Our Team'
  }
];

const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" }
];

const TYPE_OPTIONS = [
  'AI',
  'Data Center',
  'Central Office & Headend',
  'Outside Plant',
  'FTTx & MDU',
  'Rural Broadband',
  'Wireless',
  'Enterprise',
  'Medical Imaging',
  'Neuroscience',
  'Specialty Optics'
];

const TYPE_OPTIONS_NEW = [
  'Pricing, quotes, and estimations',
  'Technical support, product/service questions, or troubleshooting',
  'Order status, shipping, and tracking',
  'Billing, invoices, or returns',
  'Partnership, reseller, or distribution inquiries',
  'Career opportunities and job applications',
  'Press, media, or speaking requests',
  'Demo, consultation, or appointment scheduling',
  'Other, General feedback, or questions',
]

const SHOW_TYPES_FOR = new Set([
  "Pricing, quotes, and estimations",
  "Demo, consultation, or appointment scheduling",
]);

function Contact() {

    const [activeIndex, setActiveIndex] = useState(null);

    const getFlagEmoji = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return "";
  return countryCode
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt()))
    .join("");
};


const [formData, setFormData] = useState({
    firstName: '', // "Generic First Name": text_mkrdz3dt
    lastName: '', //"Generic Last Name": text_mkrndjr0
    companyName: '', //"company": accounts__1
    companyEmail: '', //"email": email_1__1
    phoneNumber: '', //there: phone_1__1
    country: '', //there: text_mkrne8ph
    state: '', //there: text_mkrncd4p
    message: '', //Opportunity Description/Notes: notes__1
    title: '',
    type: '',
    category: ''
    //"Lead generation date": text_mkrnpaft 


  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const analyticsFormStartedRef = useRef(false);
  const analyticsSubmittedRef = useRef(false);
  const analyticsDraftTimerRef = useRef(null);
  const analyticsLastFieldRef = useRef("");
  const latestFormDataRef = useRef(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    analyticsLastFieldRef.current = name;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

useEffect(() => {
  latestFormDataRef.current = formData;

  const hasFormData = Object.values(formData).some((value) => String(value || "").trim());

  if (!hasFormData || analyticsSubmittedRef.current) return;

  if (!analyticsFormStartedRef.current) {
    analyticsFormStartedRef.current = true;

    trackAnalyticsEvent("form_start", {
      formName: "contact",
    });
  }

  clearTimeout(analyticsDraftTimerRef.current);

  analyticsDraftTimerRef.current = setTimeout(() => {
    saveAnalyticsFormDraft("contact", formData, {
      status: "in_progress",
      lastField: analyticsLastFieldRef.current,
    });
  }, 800);

  return () => clearTimeout(analyticsDraftTimerRef.current);
}, [formData]);

useEffect(() => {
  return () => {
    if (
      analyticsFormStartedRef.current &&
      !analyticsSubmittedRef.current
    ) {
      markAnalyticsFormAbandoned(
        "contact",
        latestFormDataRef.current,
        analyticsLastFieldRef.current
      );
    }
  };
}, []);

  const today = new Date();
const formattedDate = today.toISOString().split("T")[0]; // e.g. "2025-07-16"

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  const submittedData = { ...formData };

  try {
    const res = await fetch(
      "https://us-central1-gofoton-55796.cloudfunctions.net/submitContactLead",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          formData: submittedData,
        }),
      }
    );

    const json = await res.json();

    if (!res.ok || !json.success) {
      throw new Error(
        json.error ||
        "Submission failed."
      );
    }

    analyticsSubmittedRef.current = true;

    await markAnalyticsFormSubmitted(
      "contact",
      submittedData
    );

    setSuccess(true);

    setFormData({
      firstName: "",
      lastName: "",
      companyName: "",
      companyEmail: "",
      phoneNumber: "",
      country: "",
      state: "",
      title: "",
      message: "",
      type: "",
      category: "",
    });
  } catch (err) {
    console.error(err);

    alert(
      err.message ||
      "Submission failed."
    );
  } finally {
    setSubmitting(false);
  }
};

  const formatUSPhone = (digits) => {
  const d = digits.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0,3)}) ${d.slice(3)}`;
  return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
};

const formatPhoneInput = (raw) => {
  // allow leading + for international
  const hasPlus = raw.trim().startsWith("+");
  const digits = raw.replace(/\D/g, "");

  if (hasPlus) {
    // keep it lightweight: + then up to 15 digits (E.164 max)
    return "+" + digits.slice(0, 15);
  }

  // US formatting by default
  return formatUSPhone(digits);
};

const handlePhoneChange = (e) => {
  analyticsLastFieldRef.current = "phoneNumber";
  const formatted = formatPhoneInput(e.target.value);
  setFormData((prev) => ({ ...prev, phoneNumber: formatted }));
};


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
      
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
// 1) Put your Monday column ID here (status or dropdown)
const MONDAY_TYPE_COL = "dropdown_mm0vwv27"; // <-- confirm this ID

// 2) If the column on Monday is a DROPDOWN set this to true;
//    If it's a STATUS, set to false.
const TYPE_IS_DROPDOWN = true; // <-- flip to true if it's a dropdown

// 3) Allowed labels safeguard (use exactly what exists on the board)
// const ALLOWED_TYPE_LABELS = new Set([
//   'AI',
//   'Data Center',
//   'Central Office & Headend',
//   'Outside Plant',
//   'FTTx & MDU',
//   'Rural Broadband',
//   'Wireless',
//   'Enterprise',
//   'Medical Imaging',
//   'Neuroscience',
//   'Specialty Optics',
//   'Other'
// ]);

useEffect(() => {
  const markAbandonedOnHide = () => {
    if (
      document.visibilityState !==
      "hidden"
    ) {
      return;
    }

    if (
      !analyticsFormStartedRef.current ||
      analyticsSubmittedRef.current
    ) {
      return;
    }

    markAnalyticsFormAbandoned(
      "contact",
      latestFormDataRef.current,
      analyticsLastFieldRef.current
    );
  };

  const markAbandonedOnPageHide =
    () => {
      if (
        !analyticsFormStartedRef.current ||
        analyticsSubmittedRef.current
      ) {
        return;
      }

      markAnalyticsFormAbandoned(
        "contact",
        latestFormDataRef.current,
        analyticsLastFieldRef.current
      );
    };

  document.addEventListener(
    "visibilitychange",
    markAbandonedOnHide
  );

  window.addEventListener(
    "pagehide",
    markAbandonedOnPageHide
  );

  return () => {
    document.removeEventListener(
      "visibilitychange",
      markAbandonedOnHide
    );

    window.removeEventListener(
      "pagehide",
      markAbandonedOnPageHide
    );
  };
}, []);

const ALLOWED_TYPE_LABELS = new Set([
  'AI',
  'Data Center',
  'Central Office & Headend',
  'Outside Plant',
  'FTTx & MDU',
  'Rural Broadband',
  'Wireless',
  'Enterprise',
  'Medical Imaging',
  'Neuroscience',
  'Specialty Optics'
]);

// Keep your existing SHOW_TYPES_FOR as-is
const SHOW_TYPES_FOR = new Set([
  "Pricing, quotes, and estimations",
  "Technical support, product/service questions, or troubleshooting",
]);

// Ensure we clear `type` when the category changes to one that hides it
const handleCategoryChange = (e) => {
  const value = e.target.value;
  setFormData((prev) => ({
    ...prev,
    category: value,
    type: SHOW_TYPES_FOR.has(value) ? prev.type : "" // reset if hidden
  }));
};

const countryOptions = useMemo(() => {
  const all = countryList().getData(); // [{ value: "US", label: "United States" }, ...]

  const us = all.find(c => c.value === "US");
  const rest = all
    .filter(c => c.value !== "US")
    .sort((a, b) => a.label.localeCompare(b.label));

  return us ? [us, ...rest] : rest;
}, []);
// shape: [{ value: "US", label: "United States" }, ...]

const buildColumnValues = (formData, formattedDate) => {
  const getMondayPhoneValue = () => {
    if (!formData.phoneNumber) return undefined;

    const raw = formData.phoneNumber.trim();
    const digits = raw.replace(/\D/g, "");

    // If a country was selected, use it.
    // Your country dropdown already stores ISO-2 values such as US, GB, JP, etc.
    const countryCode = (formData.country || "US").toUpperCase();

    // For US numbers, normalize to +1XXXXXXXXXX.
    if (countryCode === "US") {
      let usDigits = digits;

      // Handle someone entering 1 before the 10-digit number.
      if (usDigits.length === 11 && usDigits.startsWith("1")) {
        usDigits = usDigits.slice(1);
      }

      return {
        phone: usDigits.length === 10
          ? `+1${usDigits}`
          : raw,
        countryShortName: "US"
      };
    }

    // International numbers:
    // Preserve a leading + when the user supplied one.
    return {
      phone: raw.startsWith("+") ? `+${digits}` : digits,
      countryShortName: countryCode
    };
  };

  const v = {
    accounts__1: formData.companyName || undefined,
    text21__1: formData.title || undefined,

    email_1__1: formData.companyEmail
      ? {
          email: formData.companyEmail,
          text: formData.companyEmail
        }
      : undefined,

    phone_mm60z479: getMondayPhoneValue(),

    text_mkrne8ph: formData.country || undefined,
    text_mkrncd4p: formData.state || undefined,
    long_text__1: formData.message || undefined,

    // pulse_log_mktms3xt: { date: formattedDate },

    color_mkv74y0m: formData.category || undefined,
  };

  // Only include Product Type when:
  // - The selected Category REQUIRES it AND
  // - A valid label is selected
  const needsType = SHOW_TYPES_FOR.has(formData.category);
  const hasValidType =
    formData.type && ALLOWED_TYPE_LABELS.has(formData.type);

  if (needsType && hasValidType) {
    v[MONDAY_TYPE_COL] = TYPE_IS_DROPDOWN
      ? { labels: [formData.type] }
      : { label: formData.type };
  } else {
    delete v[MONDAY_TYPE_COL];
  }

  // Strip keys with undefined so Monday only gets real values
  Object.keys(v).forEach((k) => {
    if (v[k] === undefined) delete v[k];
  });

  return v;
};


// Full new mondayForm function (test-ready)
const mondayForm = () => {
  // tiny helper to render label + required asterisk
  const Label = ({ htmlFor, children, required }) => (
    <label htmlFor={htmlFor} style={{ display: 'inline-block', marginBottom: 6 }}>
      {children} {required && <span className="req-asterisk" aria-hidden="true">*</span>}
    </label>
  );

  // fields config (all required except phoneNumber)
  const FIELDS = [
    { name: "firstName", label: "Name", type: "text", required: true },
    { name: "companyName", label: "Company Name", type: "text", required: true },
    { name: "title", label: "Title", type: "text", required: true },
    { name: "companyEmail", label: "Company Email", type: "email", required: true },
    { name: "phoneNumber", label: "Phone Number (optional)", type: "tel", required: false },
    //{ name: "country", label: "Country", type: "text", required: true },
    //{ name: "state", label: "State", type: "text", required: true },
  ];

  return (
    <form onSubmit={handleSubmit} className="contact-form-modern">
      <h2>Get in Touch</h2>
      {success && <p className="success-message">Submitted successfully!</p>}

      {/* Text inputs */}
      {FIELDS.map(({ name, label, type, required }) => (
        <div key={name} style={{ marginBottom: 12 }}>
          <Label htmlFor={name} required={required}>{label}</Label>
          <input
            id={name}
            type={type}
            name={name}
            value={formData[name]}
            onChange={name === "phoneNumber" ? handlePhoneChange : handleChange}
            required={required}
            inputMode={name === "phoneNumber" ? "tel" : (type === "email" ? "email" : "text")}
            autoComplete={name === "phoneNumber" ? "tel" : (type === "email" ? "email" : "on")}
            placeholder={name === "phoneNumber" ? "(201) 555-1234 or +44..." : undefined}
            pattern={name === "phoneNumber" ? "^\\+?[0-9\\s().-]{7,20}$" : undefined}
            style={{ width: "100%", padding: 8 }}
          />
        </div>
      ))}

<div style={{ marginBottom: 12 }}>
  <Label htmlFor="country" required={true}>Country</Label>

  <Select
    inputId="country"
    name="country"
    options={countryOptions}
    value={countryOptions.find(c => c.value === formData.country) || null}
    onChange={(opt) => {
      analyticsLastFieldRef.current = "country";
      const countryCode = opt?.value || "";
      
      setFormData(prev => ({
        ...prev,
        country: countryCode,
        state: countryCode === "US" ? prev.state : "" // clear state if not US
      }));
    }}
    placeholder="Select a country"
styles={{
    control: (base, state) => ({
      ...base,
      minHeight: 40,
      height: 40,
      fontSize: "14px",
      boxShadow: state.isFocused ? "0 0 0 1px #8CC540" : base.boxShadow,
      borderColor: state.isFocused ? "#8CC540" : base.borderColor
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: "0 8px"
    }),
    input: (base) => ({
      ...base,
      fontSize: "14px",
      margin: 0,
      padding: 0
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "14px",
      color: "#777"
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
      lineHeight: "40px",
      display: "flex",
      alignItems: "center",
      gap: 8
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 6
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: 6
    }),
    menu: (base) => ({
      ...base,
      fontSize: "14px"
    }),
    option: (base) => ({
      ...base,
      fontSize: "14px"
    })
  }}

    isSearchable
    formatOptionLabel={(opt) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 18 }}>{getFlagEmoji(opt.value)}</span>
        <span>{opt.label}</span>
      </div>
    )}
  />
</div>

{formData.country === "US" && (
  <div style={{ marginBottom: 12 }}>
    <Label htmlFor="state" required={true}>State</Label>

    <select
      id="state"
      name="state"
      value={formData.state}
      onChange={handleChange}
      required
      aria-required="true"
      style={{ width: "100%", padding: 8 }}
    >
      <option value="" disabled>Select a state</option>
      {US_STATES.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
    </select>
  </div>
)}

      {/* CATEGORY (always shown, required) */}
      <div style={{ marginBottom: 12 }}>
        <Label htmlFor="category" required={true}>Category</Label>
        <select
          id="category"
          name="category"
          value={formData.category}
          onChange={handleCategoryChange}
          required
          aria-required="true"
          style={{ width: "100%", padding: 8 }}
        >
          <option value="" disabled>Select a Category</option>
          {TYPE_OPTIONS_NEW.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      {/* PRODUCT TYPE (only when Category is one of the two) */}
      {SHOW_TYPES_FOR.has(formData.category) && (
        <div style={{ marginBottom: 12 }}>
          <Label htmlFor="type" required={true}>Solution</Label>
          <select
            id="type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            required // safe because this element is conditionally rendered
            aria-required="true"
            style={{ width: "100%", padding: 8 }}
          >
            <option value="" disabled>Select a solution</option>
            {TYPE_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* MESSAGE (required) */}
      <div style={{ marginBottom: 12 }}>
        <Label htmlFor="message" required={true}>Tell us more!</Label>
        <textarea
          id="message"
          name="message"
          placeholder="Please provide as much detail as possible"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          required
          aria-required="true"
          style={{ width: '100%', padding: 8 }}
        />
      </div>

      <button type="submit" disabled={submitting}>
        {submitting ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  );
};


  return (
    <div className="contact-page">
      <div className="curved-header" style={{ background: isMobile ? '#8CC540' : ''}}>
        <center><h1>Contact Us</h1></center>
      </div>


   

{/* <div className="key-contacts">
      <h2>Key contacts</h2>
      <div className="tabs-contact">
        {contacts.map((contact, index) => (
          <div key={index}>
            <div
              className={`tab-contact ${activeIndex === index ? 'active' : ''}`}
              onClick={() => setActiveIndex(index === activeIndex ? null : index)}
            >
              <div className="tab-title">{contact.title}</div>
              <div className="tab-icon">{activeIndex === index ? '−' : '+'}</div>
            </div>

            {activeIndex === index && (
              <div className="tab-contact-content">
                <img src={contact.image} alt={contact.title} />
                <div className="tab-details">
                  <h3>{contact.title}</h3>
                  <p>{contact.description}</p>
                  <button>{contact.buttonText}</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div> */}



      <div className="contact-page-1">


<div className="contact-form-section" style={{ marginTop: 30, marginBottom: 50}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/contact/northern-lights.jpg" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          
          {mondayForm()}

          </div>
      </div>


  </div>

<svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="#f9f9f9" stopOpacity="1" />
      <stop offset="50%" stopColor="#f9f9f9" stopOpacity="0" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

<div className="locations-section" style={{paddingBottom: 150, marginTop: -60}}>
  <h2 className="locations-heading">Locations</h2>

  <div className="locations-grid">
    {/* US Office */}
    <div className="location-card">
      <img src="/images/locations/usa.jpg" alt="USA Office" />
      <div className="location-text">
        <h4>Global Headquarters</h4>
       <p>
        28 World's Fair Drive<br />
        Somerset, NJ 08873<br />
        United States<br />
        Tel: <a href="tel:+17324699650">+1.732.469.9650</a><br />
        Fax: <a href="tel:+17324699654">+1.732.469.9654</a>
      </p>
      </div>
    </div>

    {/* Careers/Resumes */}
    {/* <div className="location-card">
      <img src="/images/locations/usa.jpg" alt="Careers Office" />
      <div className="location-text">
        <h4>Careers/Resumes</h4>
        <p>
          28 World's Fair Drive<br />
          Somerset, NJ 08873<br />
          United States<br />
          Tel: +1.732.469.9650<br />
          E-mail: hr@gofoton.com
        </p>
      </div>
    </div> */}

    {/* Japan */}
    <div className="location-card">
      <img src="/images/locations/japan.jpg" alt="Japan Office" />
      <div className="location-text">
        <h4>Go!Foton, Inc. Japan</h4>
          <p>
            5-4-2 Tokodai, Tsukuba City<br />
            Ibaraki Prefecture, Japan<br />
            Zip Code: 300-2635<br />
            Tel: <a href="tel:+862552163442">+81-29-847-8686</a><br />
            www.gofoton.co.jp
          </p>
      </div>
    </div>

    {/* Nanjing, China */}
    <div className="location-card">
      <img src="/images/locations/china.jpg" alt="Nanjing Office" />
      <div className="location-text">
        <h4>Go!Foton Nanjing, Inc.</h4>
        <p>
          2 Qiande Road, Building C,<br />
          6 Yuhe Road, Jiangbei New Area,<br />
          Nanjing 211800, China<br />
          Tel: <a href="tel:+862552163442">+86 25 5216-3442</a><br />
          www.gofoton.cn
        </p>
      </div>
    </div>

    {/* Netherlands */}
    <div className="location-card">
      <img src="/images/locations/netherlands.jpg" alt="Europe Office" />
      <div className="location-text">
        <h4>Europe Regional Sales Office</h4>
        <p>
          Windmolen 22, 7609 NN,<br />
          Almelo, The Netherlands<br />
          Tel: <a href="tel:+31164620422">+31 (0)164 62 04 22</a><br />
          Fax: <a href="tel:+31164620417">+31 (0)164 62 04 17</a>
        </p>
      </div>
    </div>

    {/* Philippines */}
    <div className="location-card">
      <img src="/images/locations/philippines.jpg" alt="Philippines Office" />
      <div className="location-text">
        <h4>GF Micro Optics Philippines, Inc.</h4>
        <p>
          Panorama Compound 3, Lot 3, Block 1,<br />
          East Main Avenue, Phase 5,<br />
          Laguna Technopark, Binan City,<br />
          Laguna PHL 4024, Philippines<br />
          Tel: <a href="tel:+63495086089">+6349-508-6089</a><br />
          Fax: <a href="tel:+63495413253">+6349-541-3253</a>
        </p>
      </div>
    </div>
  </div>
</div>
    

<div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Learn about our vision to bring light to life</p>
        <a className="connect-button" href="/about">ABOUT US</a>
        </div>

    </div>
  );
}

export default Contact;
